// Svelte 5 no longer needs svelte/store imports for basic reactivity
import online from "../configs/status.js";
/* Firebase */
import firebase from '@app/configs/firebase.js'; //Required even if not used.
import db from '@app/configs/firestore.js';

// Create reactive state for auto-replace lists
export const autoReplaceState = $state([]);

// Function to load auto-replace lists from database
export async function loadListFromDb(userId) {
    let autoReplaceData = [];
    
    // Use local storage instead of firebase when online is set to false
    if (online) {
        let snapshot = await db.collection("users").doc(userId).collection("shortforms").get();
        snapshot.forEach(doc => {
            autoReplaceData = [...autoReplaceData, doc.data()];
        });   
    } else {
        autoReplaceData = JSON.parse(localStorage.getItem("cc-auto-replace")) || [];
    }
    
    // Sort the list by the list name
    autoReplaceData.sort((a, b) => {
        return a.name.localeCompare(b.name);
    });

    // Update the state by emptying the array and adding new items
    autoReplaceState.length = 0;
    autoReplaceData.forEach(item => autoReplaceState.push(item));
}

// Function to create a new auto-replace list
export function createList(listInfo, userId) {
    // Use local storage instead of firebase when online is set to false
    if (online) {
        db.collection("users").doc(userId).collection("shortforms").doc(listInfo.id).set(listInfo);
    } else {
        localStorage.setItem("cc-auto-replace", JSON.stringify([...autoReplaceState, listInfo]));
    }

    // Add the new item to the array without reassigning
    autoReplaceState.push(listInfo);
}

// Function to remove an auto-replace list
export function removeList(listId, userId) {
    // Use local storage instead of firebase when online is set to false
    if (online) {
        db.collection("users").doc(userId).collection("shortforms").doc(listId).delete();
    } else {
        localStorage.setItem("cc-auto-replace", JSON.stringify(autoReplaceState.filter(list => {
            return list.id !== listId;
        })));
    }
    
    // Filter in place without reassigning the state
    const itemsToKeep = autoReplaceState.filter(list => list.id !== listId);
    autoReplaceState.length = 0;
    itemsToKeep.forEach(item => autoReplaceState.push(item));
}

// Function to update an existing auto-replace list
export function updateList(listInfo, userId) {
    // Use local storage instead of firebase when online is set to false
    if (online) {
        db.collection("users").doc(userId).collection("shortforms").doc(listInfo.id).set(listInfo);
        
        let listIndex = autoReplaceState.findIndex(list => {
            return list.id === listInfo.id;
        });

        if (listIndex !== -1) {
            // Update in place without reassigning the entire array
            autoReplaceState[listIndex] = listInfo;
        }
    } else {
        let listIndex = autoReplaceState.findIndex(list => {
            return list.id === listInfo.id;
        });

        if (listIndex !== -1) {
            // Update in place without reassigning the entire array
            autoReplaceState[listIndex] = listInfo;
        }

        localStorage.setItem("cc-auto-replace", JSON.stringify(autoReplaceState));
    }
}